<script setup lang="ts">
import { NidoTexturePart } from '~/service/experience/world/nido/parts/NidoTexturePart'
import OrderSummaryPrice from '~/components/OrderSummaryPrice.vue'
import { useSurfaces } from '~/stores/surfaces'
import { NidoCode } from '~/service/experience/world/nido/enum'

const props = defineProps<{
  part: NidoTexturePart
  price: number
  showPrice: boolean
  isDouble?: boolean
}>()

const surfacesStore = useSurfaces()
await surfacesStore.init()

const surface = surfacesStore.getSurface(props.part.textureId)
</script>

<template>
  <div class="flex items-center gap-4 p-2 print:gap-2">
    <img
      class="h-14 w-14 rounded-lg border border-black"
      height="56px"
      width="56px"
      :src="$config.public.ldAdminUrl + surface?.image?.url + '/160x160/FIT'"
    />
    <div class="flex flex-col text-sm">
      <p v-if="part.code !== NidoCode.SEAT">
        <span v-if="props.isDouble">2x</span>
        {{ part.code }}
      </p>
      <p class="text-pragmatica-extended font-bold">
        {{ surface?.title }}
      </p>
      <div v-if="showPrice">
        <OrderSummaryPrice v-if="price" :price="price" />
        <p
          v-else
          class="mt-1 max-w-[100px] text-left text-sm font-bold leading-[1]"
        >
          {{ $t('nido.priceIncluded') }}
        </p>
      </div>
    </div>
    <template />
  </div>
</template>
